import './App.css';
import Header from './layouts/Header';
import Footer from './layouts/Footer';
import AppRoutes from './routes/AppRoutes';
import {BrowserRouter, useLocation} from 'react-router-dom';
import { useEffect } from 'react';

import { NotificationProvider } from './hooks/context/NotificationContext';
import Notification from './popup/Notification';

function App() {
  return (
    <BrowserRouter>
      <NotificationProvider>
        <div className="App flex flex-col min-h-[100vh]">
          <ScrollToTop />
          <Header />
          <main style={{ flex: 1 }}>
            <AppRoutes/>
          </main>
          <Footer />
          <Notification />
        </div>
      </NotificationProvider>
    </BrowserRouter>
  );
}


export default App;

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // No UI
};
